export const enTranslation = {
  site_name: "Enigma Hotels",
  transfer: {
    distance: "Distance",
    transfer: "Transfer",
    s: "Transfers",
    pickup: "Pickup",
    dropoff: "Dropoff",
    time: "Time",
    max_people: "Max <span class=\"text-bold\">{{count}} people</span></br> per vehicle",
    max_suitcases: "Max <span class=\"text-bold\">{{count}} suitcases</span></br> per vehicle",
    est_time: "Estimated time </br><span class=\"text-bold\">{{h}} {{min}}</span>",
    select_transfer: "Select your transfer from",
    arrival_details: "Arrival details",
    return_details: "Return details",
    vehicle: "Vehicle",
    from: "From",
    to: "To",
    choose_return: "Please choose transfer from {{from}} to {{to}}",
    choose_arrival: "Please choose transfer back {{from}} to {{to}}",
    continue_book: "Continue booking",
    pay_via_cc: "Pay via credit card",
    details: "Transfer details",
    arrival_info: "Arrival information",
    return_info: "Return information",
    addresses: "Addresses",
    airports: "Airports",
    diff_countries: "Start and end points are in different countries. Please pay attention.",
    from_search: "Where to pick up",
    to_search: "Where to drop off",
    pick_up_date: "Pick up date",
    pick_up_time: "Pick up time",
    pick_up: "Pick up",
  },
  hotel_info: "Hotel Price & Information",
  hotel: {
    area: "Area",
    phone: "Phone",
    rating: "Rating",
    images: "Images",
    remove_preffered: "Remove from preferred",
    hotel: "Hotel",
    s: "Hotels",
    found_from: "hotels from ",
    full_cancellation_fee: "Full cancellation fee",
    free_cancel_before: "Free cancellation before",
    show_rooms: "Show rooms",
    show_all_rooms: "Show all rooms",
    boarding: "Boarding",
    refund_limit: "Free cancellation",
    refund_price: "Refund price",
    nights: "nights",
    rooms: "Rooms",
    room: "Room",
    room_details: "Room details",
    nights_up: "Nights",
    select_room: "Select your room",
    filter: "Filter...",
    location: "Hotel Location",
    book: "Book",
    overview: "Overview",
    facilities: "Hotel facilities",
    details: "Hotel details",
    dates: "Hotel dates",
    name: "Hotel name",
    non_refundable: "Non-ref.",
    rooms_prices: "Rooms and prices ({{count}})",
    desc: "Hotel description",
    fac: "Facilities",
    gallery: "Gallery",
    choose_rooms: "Choose rooms",
    single_room: "1 Room - {{price}}",
    multi_rooms: "{{count}} Rooms - {{price}}",
    rooms_price: "Rooms and prices",
    paxes: "Paxes",
    room_type: "Room type",
    room_types: "Room AI",
    more_room_types: "{{count}} more room types",
    description: "Description",
    address: "Address",
    loc: "Location",
    hotel_facilities: "Hotel facilities",
    room_facilities: "Room facilities",
    please_note: "Please note!",
    you_can_choose: "You can choose up to {{count}} paxes",
    we_suggestion: "We found more suggestions for you",
    max_rooms: "Please choose not more then {{count}} rooms",
    max_paxes: "Please choose not more then {{count}} paxes",
    specific_out: "Specific room ran out, here is alternatives",
    select_rooms: "Select rooms",
    info: "Hotel info",
    checking_room_availability: "Checking room availability...",
    one_hotel_search_failed: "Choosen room is not available, please choose another room",
    price_per_night: "Price per night",
    grp: "Group",
    brd: "Boarding",
    bdr: "Bedroom",
    typ: "Type",
    vew: "View",
    bed: "Bed",
    ada: "Accessibility",
    pax: "Pax",
    cat: "Category",
    blc: "Balcony",
    cap: "Capacity",
    sgl: "Single use",
    shr: "Shared",
    filter_room_type: "Filter by room AI",
    open_fitler: "Open",
    show_room_types: "Show room types",
    hide_room_types: "Hide room types",
    pay_credit_card: "Pay with credit card",
    paid_successfully: "Paid successfully",
    group_rooms: "Group rooms",
    ungroup_rooms: "Ungroup rooms",
    make_the_rooms_white: "Make the rooms white",
    make_the_rooms_colored: "Make the rooms colored",
    supplier: "Supplier",
    order_summary: "Order summary",
    with_meal: "With meal",
    meal: "Meal",
    display_settings: "Display Options",
    room_display: "Room display",
    clear_room_name: "Clear room name",
    filter_rooms: "Filter similar rooms",
    our_lowest_prices: "Our lowest prices",
    show_cube_design: "Show cube design",
    show_rooms_in_tab: "Show rooms in tab",
    show_cube_design_by_eat: "Show cube design by boarding",
    is_short_mode: "Row mode",
    company_id: "Company #:",
    rem_condition: "Remarks condition",
    remarks: "Remarks",
    backoffice_trip: "BackOffice/Trip#: (0 = new trip)",
    cancellation_policy: "Cancellation policy",
    sales_price: "Sales price",
    percent: "Percent",
    amount: "Amount",
    professional: "Professional",
    client: "Client",
    professional_single: "Agent - Single Row",
    professional_single_multi: "Agent - Single Row (Multi Price)",
    professional_single_2: "Agent - Single Row For Room",
    loca: "Location",
    professional_v3: "Agent - Boarding/Category",
    business_new: "Business - Boarding/Category",
    price_new: "Business - Category/Type",
    professional_v3_multi: "Agent - Boarding/Category (Multi Price)",
    business_new_multi: "Business - Boarding/Category (Multi Price)",
    price_new_multi: "Business - Category/Type (Multi Price)",
    professional_v4: "Agent - Category/Type",
    professional_v4_multi: "Agent - Category/Type (Multi Price)",
    professional_v1: "Professional V1",
    professional_v2: "Professional V2",
    bussiness: "Bussiness",
    display_mode: "Display mode",
    room_mode: "Room mode",
    internal: "Internal",
    tab: "Tab",
    config_saved: "Config saved",
    room_changed_after_one_hotel_search: "Room changed after one hotel search",
    get_serialiezed_config: "Get serialized config",
    serialized_config_clipboard: "Serialized config copied to clipboard",
    center_me: "Center me",
    focus: "Focus",
    pin_this_item: "Pin this item",
    room_status: "Room status",
    about_room: "About room",
    room_info: "Room info",
    preffered: "Preffered",
    excluded: "Excluded",
    preferred_saved: "Preffered hotel config saved",
    language: "Language",
    positive_reviews: "Positive reviews",
    negative_reviews: "Negative reviews",
    price_breakdown: "Price breakdown",
    non_ref: "Non refundable",
    rooms_were_not_found: "Rooms were not found",
    add_special_request: "Add special request",
    please_add_special_request: "Please add special request",
    sorry_we_cant_find_hotel_here: "Sorry, we can't find hotel here",
    we_are_checking_for_better_rates: "We are Checking for Better rates",
    we_are_waiting_for_the_chosen_room: "We are waiting for the chosen room",
    original_room_description: "Original room description",
    hotel_reservation_in_process: "Hotel reservation in process",
    number_of_persons: "Number of persons",
    search_room: "Search room",
    google: "Google",
    tripadvisor: "Tripadvisor",
    monitor: "Monitor",
    copy: "Copy",
    proposal: "Proposal",
    find_nearly: "Find nearly",
    preferred_hotel: "Preferred hotel",
    system_recommended: "System recommended",
    travel_agent_recommended: "Travel agent recommended",
    client_recommended: "Client recommended",
    stars: "Stars",
    search: "Search in progress",
    prices: "Prices",
    reviews: "Reviews",
    photos: "Photos",
    positive: "Positive",
    neutral: "Neutral",
    negative: "Negative",
    rated_by_reviews: "Rated by {{rating}} reviews",
    filter_by_room_type: "Filter by room type",
    reservation_is_refundable: "This reservation is Refundable according to the fare/rate rules.",
    reservation_is_not_refundable: "This reservation is Non-Refundable according to the fare/rate rules.",
    choose_up_to_5_cards: "Choose up to 5 cards",
    multi_payment: "Multi payments",
    please_apply_every_price: "Please apply every price",
    please_enter_valid_price: "Please enter a valid price",
    view_1: "View 1",
    view_2: "View 2",
    display_style: "Display style",
    positive_reviews_tags: "Positive reviews tags",
    negative_reviews_tags: "Negative reviews tags",
    ai_notes: "AI notes",
    hotel_type: "Hotel type",
    apartment: "Apartment",
    villa: "Villa",
    view_on_website: "Hotel Website",
  },
  proposal: {
    s: "Proposals",
    remove_proposal: "Remove proposal",
    max_images_selected: "You have selected the maximum number of images",
    proposal_removed: "Proposal removed",
    display_order: "Product display order",
    proposal: "Proposal",
    no: "No proposals",
    download_pdf: "Download PDF",
    send_email: "Send Email",
    create: "Create proposal",
    clear_all: "Clear all",
    write_comments: "Write your comments here...",
    reviews: "Reviews",
    created: "Proposal was created",
    show_price: "Show price",
    please_select_rooms: "Please select rooms",
    update: "Update",
    update_all: "Update all",
    fixed_value: "Fixed value",
    percentage: "Percentage",
    edit_price: "Edit price",
    value: "Value",
    add_to: "Add to Proposal",
    details: "Details",
    amenities: "Amenities",
    all_of_images: "All of images",
    dep: "Dep.",
    dep_airport: "Dep. Airport",
    arr: "Arr.",
    arr_airport: "Arr. Airport",
    dynamic: "Dynamic",
    generated_by_user: "Generated by user",
    created_at: "Created at",
    flight_and_hotel: "Flight and hotel",
    google_images: "Important information: the images from Google hotels",
    customize: "Customize",
    simple_template: "Simple template",
    colorful_template: "Colorful template",
    contrast_template: "Contrast template",
    room_price_option: "Room price option",
    description: "Description",
    edit: "Edit Proposal",
    some_of_the_products_were_expired: "Some of the products were expired",
    by_order_id: "By order #",
    by_service_date: "By service date",
    original: "Original",
    overwrite_price: "Overwrite price",
    discount_hotel_limit: "Discount hotel limit {{minPrice}}",
    save: "Save Proposal",
    whatsapp_message: "Please find attached the travel proposal document.",
    telegram_message: "Please find attached the travel proposal document.",
    show_cancellation_date: "Show cancellation date",
    cancellation_date_delta: "Cancellation date delta",
    ai_hotel_info: "AI hotel info",
    item_view: "Item View",
    trip_view: "Trip View",
  },
  map: {
    list: "List",
    map: "Map",
    show: "Show map",
  },
  osm: {
    uturn: "Haz un cambio de sentido",
    sharp_right: "Gira bruscamente a la derecha",
    right: "Gira a la derecha",
    slight_right: "Vira ligeramente a la derecha",
    straight: "Sigue recto",
    slight_left: "Vira ligeramente a la izquierda",
    left: "Gira a la izquierda",
    sharp_left: "Gira bruscamente a la izquierda",
    turn: "en la intersección en {{distance}}.",
    new_name: "Continúa cuando el nombre de la carretera cambie a {{name}}.",
    depart: "Comienza desde esta ubicación.",
    arrive: "Has llegado a tu destino en {{name}}.",
    merge: "y incorpórate a {{name}}.",
    on_ramp: "y toma la rampa para entrar a {{name}}.",
    off_ramp: "y toma la salida hacia {{name}}.",
    fork: "en la bifurcación que encontrarás en {{name}}.",
    end_of_road: "ya que la vía termina en {{distance}}.",
    use_lane: "y mantente en el carril indicado en {{name}}.",
    continue: "por {{distance}} en {{name}}.",
    roundabout: "y entra en la rotonda en {{name}} en {{distance}}.",
    rotary: "y entra en la glorieta en {{name}} en {{distance}}.",
    roundabout_turn: "y toma la salida indicada en la rotonda en {{name}} en {{distance}}.",
    notification: "Información importante más adelante en {{name}} en {{distance}}.",
    exit_roundabout: "y sal de la rotonda en {{name}} en {{distance}}.",
    exit_rotary: "y sal de la glorieta en {{name}} en {{distance}}.",
  },
  bed_filter: {
    title: "Room filter",
    pin_only: "Pinned only",
  },
  assistant: {
    tab_tooltip: "AI Assistant",
    greeting: "Ask about hotels or flights — for example: \"flights to Paris next week\" or \"5-star hotels with breakfast\".",
    placeholder: "Ask about hotels or flights…",
    connecting: "Connecting…",
    send: "Send",
    connection_error: "Couldn't connect to the assistant. Please try again.",
    send_error: "Couldn't send your message. Please try again.",
    loading: "Loading…",
    session: "Session",
    copy_session_id: "Copy session ID",
    copied: "Copied",
    model: "AI model",
    session_viewer: "Session Viewer",
    results_opened: "Results are on the page",
    search_failed: "Couldn't open the search on the page. Please try again.",
    widget_title: "AI Assistant",
    widget_open: "Open the AI Assistant",
    widget_close: "Minimize the AI Assistant",
    widget_new_reply: "New reply from the AI Assistant",
    voice: {
      record: "Record a voice message",
      stop: "Send voice message",
      cancel: "Cancel recording",
      recording: "Recording…",
      mic_denied: "The microphone is blocked. Allow it for this site in the browser and try again.",
      unsupported: "Voice messages are not supported in this browser.",
      not_understood: "I couldn't make out that message. Please try again.",
      error: "Couldn't process the voice message. Please try again.",
      limit: "Too many voice messages. Please try again later.",
    },
    feedback: {
      open: "Rate this answer",
      sent: "Your feedback was sent. Click to change it",
      title: "Your feedback",
      q_understood: "Understood your request?",
      q_correct: "Information correct?",
      q_helped: "Helped you proceed?",
      yes: "Yes",
      no: "No",
      placeholder: "Anything else? (optional)",
      send: "Send",
      sending: "Sending…",
      thanks: "Thank you for your feedback!",
      error: "Couldn't send your feedback. Please try again.",
      close: "Close",
    },
    viewer: {
      title: "AI Assistant · Session Viewer",
      close: "Close",
      company: "Company",
      department: "Department",
      branch: "Branch",
      user: "User",
      status: "Status",
      from: "From",
      to: "To",
      search: "Search",
      search_placeholder: "Session ID or words from the chat",
      all_companies: "All companies",
      all_departments: "All departments",
      all_branches: "All branches",
      all_users: "All users",
      all_statuses: "All statuses",
      reset: "Reset",
      refresh: "Refresh",
      col_started: "Started",
      col_last: "Last activity",
      col_user: "User",
      col_company: "Company",
      col_department: "Department",
      col_branch: "Branch",
      col_messages: "Messages",
      col_status: "Status",
      col_first_message: "First message",
      empty: "No sessions match these filters.",
      error: "Couldn't load the sessions. Please try again.",
      forbidden: "Only BePro staff can open the Session Viewer.",
      rows_per_page: "Rows per page",
      range: "{{from}}–{{to}} of {{total}}",
      prev: "Previous page",
      next: "Next page",
      details: "Session",
      locale: "Language",
      search_id: "Search ID",
      tokens: "Tokens",
      tokens_short: "tokens",
      feedback_filter: "Feedback",
      col_feedback: "Feedback",
      col_tokens: "Tokens in / out",
      tokens_in_out_hint: "Tokens sent to the model / received from it",
      feedback_open: "Show the feedback",
      feedback_title: "Feedback",
      feedback_open_session: "Open session",
      feedback_empty: "No feedback in this session.",
      feedback_like: "Liked",
      feedback_dislike: "Disliked",
      feedback_comment: "Comment only",
      feedback_comment_label: "Comment",
      feedback_no_text: "No comment",
      feedback_q_understood: "Understood request",
      feedback_q_correct: "Information correct",
      feedback_q_helped: "Helped proceed",
      feedback_yes: "Yes",
      feedback_no: "No",
      feedback_unanswered: "—",
      feedback_question: "User's question",
      feedback_answer: "Assistant's answer",
      feedback_copy: "Copy for the developer",
      feedback_copy_header: "AI Assistant feedback",
      feedback_rating: "Rating",
      feedback_date: "Date",
      conversation: "Conversation",
      tool_calls: "Tool calls",
      show_tools: "Show tool calls",
      blocked_by_guard: "Blocked by guard",
      failed_calls: "Failed calls",
      role_user: "User",
      role_assistant: "Assistant",
      role_system: "System",
      input: "Input",
      error_detail: "Error",
      no_messages: "This session has no messages yet.",
    },
  },
  close: "Close",
  more: "More",
  less: "Less",
  actions: "Actions",
  all: "All",
  apply: "Apply",
  apply_2: "Apply",
  choose: "Choose",
  from: "from",
  to: "to",
  type: "Type",
  at: "at",
  km: "km",
  name: "Name",
  price: "Price",
  original_price: "Original price",
  reset: "Reset",
  continue: "Continue",
  total: "Total",
  basis: "Basis",
  taxes: "Taxes",
  back: "Back",
  days_sm: "d",
  hours_sm: "h",
  minutes_sm: "m",
  confirm: "Confirm",
  title: "Title",
  male: "Male",
  female: "Female",
  child: "Child",
  success: "Success",
  failed_order: "Order failed. Please call support",
  error: "Error",
  notes: "Notes",
  note: "Note",
  show_less: "Show less",
  show_more: "Show more",
  show_all: "Show all",
  no_entries: "No entries",
  best: "Best",
  day: "Day",
  ok: "OK",
  of: "of",
  add: "Add",
  save: "Save",
  yes: "Yes",
  delete: "Delete",
  order_created_successfully: "Order created successfully",
  session_expired_try_again: "Session expired. Please try again",
  cancel: "Cancel",
  NOFSHON: "NOFSHON",
  change_choice: "Change choice",
  click_here: "Click here",
  details: "Details",
  clear: "Clear",
  clear_all: "Clear all",
  REG: "סדיר",
  pay_wait: "Plase wait...",
  pay_wait_text: "Your order is being processed",
  pay_processing: "Payment processing...",
  normal: "Normal",
  credit: "Credit",
  only_english_input: "Please fill in first name and last name in English as it appears in the passport",
  nights: "nights",
  something_went_wrong: "Something went wrong",
  accessibility: "Accessibility",
  payment_error: "The payment failed.",
  MultipleDestinations: "Multiple cities",
  RoundTrip: "Round trip",
  OneWay: "One way",
  eEconomyClass: "Economy",
  eEconomyPlusClass: "Economy Plus",
  eBusinessClass: "Business",
  rules: "Rules",
  click_for_details: "Click for details",
  TRAVELFUSION: "LOW",
  ro: "Room only",
  bb: "Breakfast included",
  fb: "Full board",
  ai: "All inclusive",
  show_cancellation_date: "Show cancellation date",
  cancellation_date_delta: "Cancellation Date Delta",
  add_to: "Add to proposal",
  max_images_selected: "Maximum 3 images can be selected",
  ai_hotel_info: "AI Hotel Info",
  claude: {
    pets: "Pets",
    cancellation: "Cancellation",
    adults_only: "Adults only",
    website: "Website",
    notes: "Notes",
    pros: "Pros",
    cons: "Cons",
    pros_cons: "Pros & Cons",
    not_found: "Hotel was not found",
  },
  login: {
    login: "Login",
    login_your: "Login your account",
    username: "Username",
    password: "Password",
    success: "Logged in successfully",
    off_success: "Logged off successfully",
    error: "Wrong username or password",
    off: "Log off",
    contact_us: "Contact us",
    get_back: "Get back to us",
    select_number: "Select number of passengers",
    full_name: "Full name",
    contact_us_success: "Your message has been sent successfully",
    contact_us_error: "An error occurred while sending your message",
    as: "Logged in as",
    usercode: "User Code",
  },
  validation: {
    numbers: "Only numbers are allowed",
    email: "Incorrect email",
    required: "Field is mandatory",
    minLength: "Field must contain {1} characters or more",
    maxLength: "Field must contain {1} characters or less",
    length: "Field must contain {1} characters",
    english: "Only english characters are allowed",
  },
  mo: {
    mo: "My orders",
    segment_gross_edited: "Segment gross edited successfully",
    lock_pnr: "Lock PNR",
    unlock_pnr: "Unlock PNR",
    lock_pnr_success: "PNR locked successfully",
    unlock_pnr_success: "PNR unlocked successfully",
    logs: "Logs",
    open_log: "Open log",
    table_settings: "Table settings",
    support_ticket: "Support ticket",
    support_ticket_success: "Support ticket created successfully",
    subject: "Subject",
    reply: "Reply",
    ticket: "Ticket",
    ticket_updated: "Ticket updated successfully",
    segment_id: "Segment Id",
    order_id: "Order Id",
    order: "Order",
    local: "Local",
    supplier_pnr: "Supplier PNR",
    backoffice_id: "Backoffice Id",
    passenger_name: "Passenger Name",
    creation_date: "Creation Date",
    orders: "Orders",
    segment: "Seg.",
    segment_full: "Segment",
    docket: "Docket",
    pnr: "PNR",
    start: "Start",
    name: "Name",
    dest: "Dest",
    items: "Items",
    clx: "CLX",
    status: "S",
    voucher: "V",
    quantity: "Q",
    total: "Total",
    pay: "P",
    supplier: "S",
    end: "C",
    agent: "Agent",
    branch: "Branch",
    order_details: "Order details",
    check_in: "Check in",
    check_out: "Check out",
    nights: "Nights",
    date_c: "Date C",
    segment_details: "Segment details",
    paxes: "P.",
    legs: "L.",
    class: "C.",
    date_time: "DateTime",
    arrival: "Arrival",
    status_full: "Status",
    pnr_ref: "PNR Ref.",
    supplier_full: "Supplier",
    emergency_phone: "Emergency phone",
    support_email: "Support email",
    emergency_email: "Emergency email",
    amount: "Amount",
    gross: "Gross",
    coupon_code: "Coupon Code",
    total_gross: "Total Gross",
    total_net: "Total Nett",
    disc_coupon: "Dis. Cupon",
    vat: "Vat",
    total_due: "Total DUE",
    client_id: "Client Id",
    discount: "Discount",
    comission: "Comission",
    profit: "Profit",
    remarks: "Remarks",
    remark: "Remark",
    info: "Info",
    remark_code: "Code",
    order_seg_remark_id: "Remark Id",
    desc: "Message",
    user: "User",
    dateC: "Date C",
    depatment: "Depatment",
    voucher_full: "Voucher",
    print_voucher: "Print Voucher",
    voucher_number: "Voucher Number",
    backoffice_voucher_identity_number: "Backoffice Voucher Identity Number",
    status_the_same: "Status is the same",
    status_changed: "Status was changed to {{status}}",
    current_status: "Current status",
    product_type: "Product type",
    back_to_orders: "Back to Orders",
    cancel_order: "Cancel Order",
    segments: "Segments",
    booking_about_to_cancel: "This booking is about to cancelled.",
    are_you_sure: "Are you sure?",
    order_cancelled: "Order cancelled successfully. Status was changed to {{status}}",
    hello: "Hello",
    user_code: "User code",
    department: "Department",
    loading: "Loading...",
    supp: "Supp",
    pnr_to_docket: "PNR to Docket",
    docket_success: "Docket saved successfully",
    clipboard_success: "Data copied to clipboard",
    no_data_found: "No data found",
    room_preferences: "Room Preferences",
    guest_notes: "Guest Notes",
    additional_requirements: "Additional Requirements",
    please_double_bed: "If possible, please confirm a room with a <b>double bed</b>",
    please_twin_beds: "If possible, please confirm a room with <b>two twin beds</b>",
    please_high_floor: "If possible, please confirm a room on a <b>high floor</b>",
    please_low_floor: "If possible, please confirm a room on a <b>low floor</b>",
    please_non_smoking: "If possible, please confirm a <b>non-smoking</b> room",
    please_smoking: "If possible, please confirm a <b>smoking</b> room",
    please_adjoining_room: "If possible, please confirm an <b>adjoining</b> room",
    please_connecting_rooms: "If possible, please confirm <b>connecting</b> rooms",
    please_quiet_room: "If possible, please confirm a <b>quiet</b> room",
    please_bathtub: "If possible, please confirm a room with a <b>bathtub</b>",
    please_accessible_room: "If possible, please confirm an <b>accessible</b> room or <b>disabled-friendly</b> room with a <b>roll-in shower</b> (client uses a wheelchair)",
    note_late_arrival: "Please note the guest will be arriving <b>late (after 7:00 PM)</b>",
    confirm_early_arrival: "Please confirm <b>early arrival</b> at approximately: ______",
    confirm_late_arrival: "Please confirm <b>late arrival</b> at approximately: ______",
    confirm_late_checkout: "Please confirm <b>late check-out</b> at approximately: ______",
    note_no_voucher: "Please note: <b>guest will arrive without a voucher</b>",
    note_honeymoon: "Please note: <b>passengers are on their honeymoon</b>",
    confirm_baby_cot: "If possible, please confirm a <b>baby cot</b> for:<br>Infant’s full name: {{fullName}} Date of birth: {{dob}}",
    add_confirm_baby_cot: "Please add a baby to the room, if possible, and confirm a baby cot for him full name: {{fullName}} Date of birth: {{dob}}",
    if_child: "This is if the baby is in the order",
    if_no_child: "If the baby is not in the order",
    please_enter_info_about_baby: "Please enter info about baby",
    change_request: "Special request",
    change_request_success: "Special request sent successfully",
    choose_requests_can_edit: "Choose request(s) from list. You can edit request text here.",
    order_information: "Order - Information",
    order_public_price: "Order - Public Price",
    order_send_order_email: "Order - Send Order Email",
    order_agent: "Order - Agent",
    order_operator: "Order - Operator",
    print: "Print",
    send: "Send",
    print_file_generated: "Print file generated successfully",
    documents: "Documents",
    file_name: "File name",
    file_type: "File type",
    tran_id: "Tran. Id",
    ptr_id: "PTR Id",
    reason: "Reason",
    token: "Token",
    p: "P",
    a: "A",
    t: "T",
    err_code: "ErrCode",
    payments: "Payments",
    order_report: "Order Report",
    order_report_sent_success: "Order report sent successfully",
    send_to_me: "Send email to me {{email}}",
    thin_report: "Thin Report",
    email_success: "Email sent successfully",
    voucher_type: "Voucher Type",
    regular_voucher: "Regular Voucher",
    thin_voucher: "Thin Voucher",
    display_order: "Display Order",
    issue_voucher: "Issue Voucher",
    copied: "Text saved to clipboard",
    link_copied: "Link copied to clipboard",
    send_support_message: "Send support message",
    send_support_message_success: "Support message sent successfully",
    add_comission: "Add comission",
    item: "Item",
    search_again: "Search again",
    download_success: "Download success",
    units: "Units",
    order_list_report: "Order List Report",
    order_list_report_no_names: "Order List Report - No Names",
    order_list_report_by_param: "Order List Report By Param",
    order_list_report_by_dest: "Order List Report By Destination",
    summary_report_by_department: "Summary Report By Department",
    summary_report_by_branch: "Summary Report By Branch",
    summary_report_by_supplier: "Summary Report By Supplier",
    orders_by_branch: "Orders By Branch",
    orders_by_currency: "Orders By Currency",
    orders_by_supplier: "Orders By Supplier",
    export_to_file: "Export To File",
    export_to_file_no_names: "Export To File - No Names",
    export_to_file_refund: "Export To File - Refund",
    refund_report: "Refund Report",
    coupon_report: "Coupon Report",
    report_price: "Report Price",
    public_price: "Public Price",
    sys_total_agent: "Sys Total - Agent",
    sys_nett_operator: "Sys Nett - Operator",
    report_type: "Report Type",
    report: "Report",
    report_generated: "Report generated successfully",
    currency: "Currency",
    tour_subject: "Tour subject",
    add_remark: "Add Remark",
    remark_added: "Remark added successfully",
    ticket_number: "Ticket number",
    public: "Public",
    private: "Private",
    body: "Body",
    support_update: "Update ticket",
    support_update_success: "Ticket updated successfully",
    itinerary: "Itinerary",
    include: "Included",
    not_included: "Not included",
    information: "Information",
    start_price: "From",
    change_user: "Change user",
    change_user_success: "User changed successfully",
    current_user: "Current user",
    data_saved: "Data saved successfully",
    agency: "Agency",
    currencies: "Currencies",
    upload_logo: "Upload logo",
    current_logo: "Current logo",
    new_logo: "New logo",
    last_update: "Last update",
    download: "Download",
    documents_uploaded_successfully: "{{count}} documents uploaded successfully",
    no_files_selected: "No files selected",
    choose_files: "Choose files",
    delete_document: "Delete document",
    document_deleted: "Document deleted successfully",
    all_departments: "All departments",
    all_branches: "All branches",
    profile: "Profile",
    set_different_user: "Set different user",
    login_as: "Login as",
    username: "Username",
    reset: "Reset",
    logged_as_user_successfully: "Logged in as user successfully",
    logged_as_user_reset_successfully: "Logged out as successfully",
    add_payment: "Add payment",
  },
  destination: {
    s_our_top: "Our recommended destinations",
  },
  search: {
    new: "New Search",
    remember_mode_enabled: "Remember mode enabled",
    open_details_in_new_tab: "Open details in new tab",
    your_latest_searches: "Your latest searches",
    radius: "Radius",
    no_results: "No results found",
    destination: "Destination",
    check_in: "Check in",
    check_out: "Check out",
    max_occupancy: "Max occupancy",
    rooms: "Rooms",
    room: "Room",
    star_rating: "Star rating",
    nationality: "Nationality",
    adults: "Adults",
    children: "Children",
    youths: "Youths",
    seniors: "Seniors",
    infants: "Infants",
    adult: "Adult",
    child: "Child",
    youth: "Youth",
    senior: "Senior",
    infant: "Infant",
    under: "under",
    add_room: "Add room",
    search: "Search",
    max_persons: "Max persons: {{count}}",
    infants_warning: "Infants count must be less than adults count",
    history: "Search history",
    age: "Child age (2-16)",
    suppliers: "Suppliers",
    with_active_filters: "Keep Filters",
    display_exactly: "Display Exactly",
    search_type_id: "Search type id",
  },
  sort: {
    er: "Sorter",
    by: "Sort by",
    price_increase: "Price: low to high",
    price_decrease: "Price: high to low",
    cxl_increase: "CXL: low to high",
    cxl_decrease: "CXL: high to low",
    airline_increase: "Airline: (A - Z)",
    airline_decrease: "Airline: (Z - A)",
    star_increase: "Star: low to high",
    star_decrease: "Star: high to low",
    hotel_increase: "Name: (A - Z)",
    hotel_decrease: "Name: (Z - A)",
    duration_increase: "Duration: low to high",
    duration_decrease: "Duration: high to low",
    departure_outbound_increase: "Earliest take-off ({{dep}})",
    departure_outbound_decrease: "Latest take-off ({{dep}})",
    returning_outbound_increase: "Earliest landing ({{arr}})",
    returning_outbound_decrease: "Latest landing ({{arr}})",
    departure_inbound_increase: "Earliest take-off ({{arr}})",
    departure_inbound_decrease: "Latest take-off ({{arr}})",
    returning_inbound_increase: "Earliest landing ({{dep}})",
    returning_inbound_decrease: "Latest landing ({{dep}})",
    recommended: "Recommended",
    distance: "Distance",
    distance_increase: "Distance: (0 - 100)",
    distance_decrease: "Distance: (100 - 0)",
    name: "Name",
    star: "Star",
  },
  group: {
    gr: "Group",
    special: "Special",
    group: "Special Request",
    request: "Special Request",
    request_type: "Request type",
    hotel: "Hotel",
    flight: "Flight",
    destination: "Destination",
    hotel_name: "Hotel name",
    room_type: "Room type",
    double: "Double",
    single: "Single",
    triple: "Triple",
    quadro: "Quadro",
    group_type: "Request type",
    hotel_stars: "Hotel stars",
    stars_5: "5 stars",
    stars_4: "4 stars",
    stars_3: "3 stars",
    stars_2: "2 stars",
    star_1: "1 star",
    number_of_rooms: "Number of rooms",
    check_in: "Check in",
    check_out: "Check out",
    contact_information: "Contact information",
    agency_name: "Agency name",
    agent_fn: "Agent first name",
    agent_ln: "Agent last name",
    agent_email: "Agent email",
    agent_phone: "Agent phone",
    message: "Message",
    send_request: "Send request",
    request_sent: "Request sent successfully",
    from: "From",
    to: "To",
    date: "Date",
    flight_time: "Flight time",
    airline: "Airline",
    number_of_passengers: "Number of passengers",
  },
  filter: {
    filter: "Filter",
    free_text: "Free text",
    s: "Filters",
    stops: "Stops",
    stop: "stop",
    stop_up: "Stop",
    stops_sm: "stops",
    direct_flight: "Direct flight",
    direct_flights: "Direct flights",
    direct_flights_outbound: "Direct flights outbound",
    one_stop: "1 stop",
    two_or_more_stops: "2+ stops",
    reset: "Reset filters",
    price_range: "Price range",
    times: "Times",
    takeoff: "Take-off",
    landing: "Landing",
    duration: "Duration",
    stop_duration: "Stop duration",
    airlines: "Airlines",
    airports: "Airports",
    by_name: "Name",
    by_rooms: "Rooms",
    by_stars: "Stars",
    by_prices: "Prices",
    search_by_location: "Search by location",
    more: "More filters...",
    free_cancellation: "Free cancellation",
    board: "Board",
    clear: "Clear filters",
    baggage: "Baggage",
    baggage_included: "Baggage included",
    baggage_not_included: "Baggage not included",
    meal: "Meal",
    airline: "Airline",
    free_x: "Free",
    is_less_than: "Is less than",
    is_greater_than: "Is greater than",
    free: "Free X",
    preffered_hotels: "Preffered hotels",
    breakfast: "Breakfast",
    half_board: "Half board",
    full_board: "Full board",
    all_inclusive: "All inclusive",
    max_price: "Max price",
    min_price: "Min price",
    max: "Max",
    min: "Min",
  },
  home: {
    home: "Home",
    session_expired: "Session expired",
    session_expired_desc: "Your session has expired. Try to search again",
    go_back: "Go back home",
    search_out_of_date: "Search results may be out of date",
    please_refresh: "Please refresh the search results",
    refresh_results: "Refresh results",
    new_search: "New search",
    confirmation_dialog: "Confirmation dialog",
    password: "Password",
    wrong_password: "Wrong password",
    failed_to_pay: "Failed to create order, order was cancelled during the booking process. Please try again",
  },
  passenger: {
    as_client: "As client",
    as_agent: "As agent",
    details: "Passenger details",
    important_notes: "Important notes",
    apartment_notes: "Please be aware: Reception is not available in some apartments. Check-in is online, and access codes are sent in advance.",
    passenger: "Passenger",
    s: "Passengers",
    guest: "Guest",
    guests: "Guests",
    gender: "Gender",
    male: "Male",
    female: "Female",
    ln: "Last name",
    fn: "First name",
    dob: "Date of birth",
    phone: "Phone",
    email: "Email",
    confirm: "Please Confirm That You Accept Terms",
    read_more: "Read more",
    attention: "Attention! Your reservation is already in penalty policy",
    order_details: "Order details",
    cancellation_details: "Cancellation details",
    cancellation_date: "You may cancel your order no later than",
    cancellation_outdate: "Cannot be cancelled. Full cancellation fee",
    booking_summary: "Booking summary",
    room_count: "Room count",
    confirm_order: "Confirm order",
    room: "Room",
    optional_services: "Optional Services (Baggage & Meals)",
    methods_of_payment: "Methods Of Payment",
    fast_secure: "Fast, secure payment by credit card",
    transaction_type: "Transaction type",
    number_of_payments: "Number of payments",
    send_request_to_consultant: "Send a request to treat Travel Consultant",
    green_button_tooltip: "Do you prefer to pay to one of our representatives? Press the green botton to reserve your seat and a representative will call you shortly.",
    send_request: "Send request",
    rule_display: "Rule Display",
    rule_i: "Rule {{i}}. {{fareBase}} | {{airlineCode}} | {{departureCode}}-{{arrivalCode}}",
    message: "Message",
    birthday: "Birthday",
    years: "years",
    confirm_order_text: "Confirm book order",
    mr: "Mr.",
    mrs: "Mrs.",
    miss: "Miss.",
    ms: "Ms.",
    dr: "Dr.",
    prof: "Prof.",
    title: "Title",
    phone_country: "Phone country",
    add: "Add passenger",
    passport_valid_till: "Passport valid until",
    passport: "Passport",
    price_for_single_in_composition_for_double: "Price for single in composition for double",
    order_id: "Order ID",
    id_number: "ID number",
    cancel_order_success: "Sent successfully",
    city: "City",
    branch_title: "Branch title",
    display_cancellation_policy: "Display cancellation policy",
    please_wait: "Please wait...",
    your_payment_is_being_processed: "Your payment is being processed",
    fast_secure_multi_payment: "Fast, secure payment by up to {{count}} credit cards",
    procces_with_revolut: "Procces with Revolut",
    pay: "Pay",
    every_hotel_has_room: "Every hotel must have a room",
  },
  access: {
    accessibility_settings: "Accessibility Settings",
    internet_accessibility: "Internet accessibility means that people with disabilities can use the internet",
    contrast: "Contrast",
    dark: "Dark",
    normal: "Normal",
    bright: "Bright",
    color: "Color",
    high: "High",
    black_white: "Black and White",
    font_size: "Font Size",
    clear_selection: "Clear Selection",
  },
  deal: {
    tours: "Tours",
    fly_drive: "Fly Drive",
    nofshon: "Touristic Package",
    ski: "Ski",
    spa: "Spa",
    sport: "Sport",
    cruise: "Cruise",
  },
  cookie: {
    cookie_policy: "Cookie Policy",
    title: "We value your privacy.",
    text: "We use cookies to enhance your browsing experience, serve personalized ads or content, and analyze our traffic. By clicking \"Accept All\", you consent to our use of cookies.",
    accept: "Accept All",
    reject: "Reject All",
  },
  package: {
    package: "Package",
    s: "Packages",
    type: "Type",
    destination: "Destination",
    room_type: "Room type",
    tours: "Tours",
    depart: "Depart",
    return: "Return",
    price_per_person: "Price per person",
    total_price: "Total price",
    deal_features: "Deal features",
    nights: "Number of Nights",
    nts: "Nights",
    package_type: "Package Type",
    occupancy: "Occupancy",
    details: "Package details",
    category: "Category",
    taxes: "Taxes",
    per_person: "avg/package",
    board_type: "Boadrd type",
    country: "Country",
    language: "Language",
    including: "Including",
    not_including: "Not including",
    more_info: "More info",
    terms_of_cancellation: "Terms of cancellation",
    important_info: "Important Information!",
    it_is_your_res: "It is your responsibility to read the website ",
    terms_of_use: "terms of use ",
    and_all_conditions: " and all terms and conditions regarding your order",
    general_conditions: "General conditions and cancellations",
    alphabetically: "Alphabetically",
    popular: "Popular destinations",
    per_trip: "Per trip",
    provider: "Provider",
    flight: "Flight details",
    select_num_pax: "Select number of passengers",
    supplier_terms: "Supplier terms",
    immediate_approval: "Immediate approval",
    please_select_flight: "Please select flight",
    status_go_to_m_or_req_1: "Order No.: {{number}} has been forwarded to the supplier for approval.",
    status_go_to_m_or_req_2: "Upon final confirmation of the order, you will be sent another email containing the confirmed order details.",
    you_need_to_choose_room_first: "You need to choose room first",
    catalog_additional_payments: "Catalog additional payments",
    sorry_we_couldnt_locate_item: "Sorry, we couldn’t locate the item.",
    room_no: "Room No.",
    complect: "Complect",
    room_type_accommodation_base: "Room type accommodation base",
    add_room_to_reservation: "Add room to reservation",
    room_selection: "Room selection",
  },
  tour: {
    tour: "Tour",
    s: "Tours",
  },
  tlv: "TLV - Tel Aviv",
  flight: {
    flight: "Flight",
    s: "Flights",
    from: "Leaving from",
    to: "Going to",
    departing: "Departing",
    returning: "Returning",
    date: "Date",
    choose_persons: "Travelers",
    dates: "Dates",
    details: "Flight details",
    class: "Flight class",
    economy: "Economy",
    business: "Business",
    economy_premium: "Economy Premium",
    baggage: "Baggage",
    round_trip: "Round trip",
    one_way: "One way",
    multiple_destinations: "Multiple cities",
    found_from: "flights found from ",
    details_segment: "Flight details",
    forward: "Forward",
    total_price: "Total price",
    avarage_per_passenger: "Average per passenger",
    seats_available: "seats available",
    no_suitcases_allowed: "No suitcases allowed",
    airline_allow_one: "Airline allow one suitcase",
    airline_allow_multiple: "Airline allow {{count}} suitcases",
    airline_allow_max: "Airline allow suitcase up to {{weight}}",
    outbound: "Outbound",
    inbound: "Inbound",
    direct_only: "Direct only",
    order_details: "Order details",
    order_summary: "Order summary",
    departure_date: "Departure date",
    return_date: "Return date",
    usa_warning: "Please note in case of crossing or stopping in the United States a visa is required even if it is a connecting flight, it is the customer's responsibility to issue it or request it.",
    total_average_passenger: "Total average passenger",
    total_per_package: "Total Per Package",
    departure: "Departure",
    return: "Return",
    departure_time: "Departure time",
    departure_airport: "Departure airport",
    arrival_time: "Arrival time",
    arrival_airport: "Arrival airport",
    aircraft: "Aircraft",
    seats_available_up: "Seats available",
    show_details: "Show details",
    frequent_flyer_airline: "Flight Frequent flyer Airline",
    frequent_flyer_number: "Flight Frequent flyer Number",
    updgrade: "Upgrade your chosen flight",
    info_and_conditions: "Info and General Conditions",
    it_is_your: "It is your responsibility to read ",
    all_rules: "all the rules and restrictions",
    according_this: " according this flight",
    booking_summary: "Booking summary",
    airport: "Airport",
    service_time: "Service time",
    pickup_time: "Pickup time",
    additional_info: "Additional informaton",
    number: "Flight number",
    to_airport: "To airport",
    handbag_included: "Hand bag",
    handbag_excluded: "No handbag",
    trolley_excluded: "No trolley",
    trolley_included: "Trolley",
    bag_included: "Baggage",
    bag_excluded: "No Baggage",
    airline_desc_and: "Airline description and",
    link: "link",
    airline: "Airline",
    dep_time: "Departure time",
    arr_time: "Arrival time",
    dep_airport: "Departure airport",
    arr_airport: "Arrival airport",
    elapsed_time: "Elapsed time",
    all_baggage_information_on_the_airline_website: "All baggage information on the airline website",
    operated_by: "Operated By",
    base: "Base",
    tax: "Tax",
    SFM: "SFM",
    book_2: "Book 2 Legs",
    professional_mode: "Professional Mode",
    client_mode: "Client Mode",
    incl_handbag: "Incl. Handbag",
    incl_suitcase: "Incl. Suitcase",
    incl_bag: "Incl. Baggage",
    incl_baggage: "Incl. Baggage {{price}}",
    incl_suitcase_kg: "Incl. Suitcase {{kg}} kg",
    no_baggage: "No Baggage",
    incl_handbag_kg: "Incl. Handbag {{kg}} kg",
    without_handbag: "Without Handbag",
    add_another_flight: "Add flight",
  },
  dyn: {
    dynamic: "Sports and music packages",
    predefined: "Recommended package",
    self: "Self assembly",
    event_type: "Event type",
    event_music: "Destination / Artist / Festival",
    event_sport: "Target / Team / League",
    sport_type: "Sport type",
    people: "People",
    sport: "Sport",
    music: "Music",
    package_details: "Package details",
    ticket: "Ticket",
    from_here: "From here",
    your_choice: "Your choice",
    extra_money: "Extra for each passenger",
    filter_results: "Filter search results",
    not_found: "Attraction not found",
    fl_htl_ticket: "Flight + hotel + entrance",
    fl_pl_htl: "Flight + hotel",
    image_for_illustration: "The image of the stadium/hall is for illustration only",
    supplement_card: "Supplement to the card",
    card_category: "The card category",
    to_order: "To order",
    outbound_flight: "Outbound",
    return_flight: "Return",
    card: "Event Details",
    tickets_amount: "Tickets amount",
    ticket_date: "Date of event",
    terms: "Terms of using this site",
    general_conditions: "General conditions and cancellation fees",
    its_your_read: "It is your responsibility to read",
    general_conditions_cancellation: "General conditions and cancellations",
    all_conditions_time: "and all the terms and conditions regarding your time",
    the_event_ticket: "The event ticket",
    full_cancellation_fees: "is subject to full cancellation fees",
    no_cancellation_fees: "No cancellation fees until",
    handling_fees: "Handling fees",
    cancellation_50: "For handling the cancellation of a reservation, Tour company will charge $50 per passenger in addition to the cancellation fees of the various suppliers",
    from_the_moment: "from the moment the order is placed",
    add_forward_transfer: "Add transfer from airport to hotel",
    add_two_way_transfer: "Add transfer from airport to hotel and back",
    arrival_transfer: "Arrival transfer",
    return_transfer: "Return transfer",
    no_avail: "Sorry we didn't find an available package",
    search_again: "Search again",
    fl_htl: "Flight + hotel",
    select_fare: "Select fare {{from}} to {{to}}",
    change_fare: "Change fare",
    per_passenger: "Per passenger",
    hotel_not_found: "Hotel not found",
    flight_not_found: "Flight not found",
    error: "Something went wrong",
    attraction_not_found: "Attraction not found",
    tlv: "TLV - Ben Gurion International, Tel Aviv Yafo",
    event_date_warning: "Event date must be within the selected dates",
    choose_room: "Choose Room",
    event: "Event",
    packages: "Dynamic packages",
    there_is_no_any_room_please_choose_another_hotel: "There is no any room please choose another hotel",
  },
};
